import { html, ref } from '@microsoft/fast-element';
import { closeIcon } from '../_common/icons';
export const foundationToastTemplate = html `
  <div class="toast ${(x) => x.deleteAnimation}" ${ref('toast')}>
    <div class="content-wrapper">
      <div part="top" class="top">
        <slot name="top"></slot>
        <div class="close-icon" @click=${(x) => x.close()}>${closeIcon()}</div>
      </div>
      <div part="content" class="content">
        <slot name="content"></slot>
      </div>
      <div part="date" class="date">
        <slot name="date"></slot>
      </div>
      <div part="bottom" class="bottom">
        <slot name="bottom"></slot>
      </div>
    </div>
  </div>
`;
